module.exports = __webpack_public_path__ + "static/media/image-placeholder.9cef7303.svg";